/**
 * A task title as a client reads it (founder 6441608339 D, the demo walk of 2026-10-27).
 *
 * Generated engagement tasks carry a working prefix, "R11 [QA] Write and execute…": the requirement code
 * and the persona that drafted it. Under Presenting the prefix is dropped from what is SHOWN; the stored
 * title, search and every link keep it.
 */
// Every tag the generator writes (app/services/scope_change_proposals.py: ENG, QA, PM, TRN, DOC, INT).
const WORK_PREFIX = /^(?:R\d+\s+)?\[(?:ENG|TRN|QA|PM|INT|DEV|BA|DOC|OPS)\]\s+/;

export function plainTaskTitle(title: string, presenting: boolean): string {
  if (!presenting) return title;
  const plain = title.replace(WORK_PREFIX, "");
  return plain ? plain.charAt(0).toUpperCase() + plain.slice(1) : title;
}
